const setErrors = async (context, errors) => {
  context.commit("SET_ERRORS", errors);
};

const setAlert = async ({ commit }, alert) => {
  commit("SET_ALERT", alert);
};

const setErrorsNotAcceptable = async ({ commit }, data) => {
  let errors = {
    title: "ERRO DE PREENCHIMENTO",
    type: "error",
    errors: [],
    timeout: 8000
  };

  Object.entries(data).forEach(async element => {
    if (element[element.length - 1]) {
      var arrayErrors = element[element.length - 1];
      arrayErrors.forEach(error => {
        errors.errors.push(error);
      });
    }
  });
  commit("SET_ALERT_NOT_ACCEPTABLE", errors);
};

const hideAlert = async ({ commit }) => {
  commit("HIDE_ALERT");
};

const destroyErrors = async context => {
  context.commit("SET_ERRORS", []);
};

const destroyErrorsNotAcceptable = async context => {
  context.commit("SET_ERRORS_NOT_ACCEPTABLE", []);
};

export default {
  setErrors,
  setAlert,
  setErrorsNotAcceptable,
  hideAlert,
  destroyErrors,
  destroyErrorsNotAcceptable
};
